export default "__VITE_ASSET__02bc978c__"